<template>
  <button :class="triggerClass" class="btn" type="button" @click="$emit('open')">
    <em class="align-middle material-icons">{{ triggerIcon }}</em> {{ triggerText }}
    <slot name="trigger"></slot>
  </button>

  <teleport v-show="show" to="body">
    <div ref="modal" aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal modal-lg fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button aria-label="Close" class="btn-close" type="button" @click="$emit('close')"></button>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" type="button" @click="$emit('close')">Close</button>
            <button class="btn btn-primary" type="button" @click="$emit('save')">{{ submitBtn }}</button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

</template>

<script>
import {Modal} from 'bootstrap';

export default {
  emits: ['close', 'open', 'save'],
  name: "BootstrapModal",
  props: ['show', 'title', 'submitBtn', 'triggerIcon', 'triggerText', 'triggerClass'],
  data() {
    return {
      modal: null
    }
  },
  watch: {
    show(newVal) {
      if (newVal)
        this.modal.show();
      else
        this.modal.hide();
    }
  },
  mounted() {
    this.modal = new Modal(this.$refs.modal);
    this.$refs.modal.addEventListener('hide.bs.modal', () => {
      this.$emit('close')
    });
  }
}
</script>

<style scoped>

</style>